import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem, StyledTable } from "./Components";
import ser_haz_lev from "../img/sswpIcons/SewersCulvertsMains/ser_haz_lev.png";
import ser_det_mar from "../img/sswpIcons/SewersCulvertsMains/ser_dec_mar.png";
import ser_div_off from "../img/sswpIcons/SewersCulvertsMains/ser_div_off.png";
import ser_han_dig from "../img/sswpIcons/SewersCulvertsMains/ser_han_dig.png";
import ser_no_fla from "../img/sswpIcons/SewersCulvertsMains/ser_no_fla.png";
import ser_oh_lin from "../img/sswpIcons/SewersCulvertsMains/ser_oh_lin.png";
import ser_per_to_wor from "../img/sswpIcons/SewersCulvertsMains/ser_per_to_wor.png";
import ser_ser_sup from "../img/sswpIcons/SewersCulvertsMains/ser_ser_sup.png";
import ser_sur_map from "../img/sswpIcons/SewersCulvertsMains/ser_sur_map.png";
import ser_tag_on_off from "../img/sswpIcons/SewersCulvertsMains/ser_tag_on_tag_off.png";

import ser_bar_fen_hoa from "../img/sswpIcons/SewersCulvertsMains/ser_bar_fen_hoa.png";
import ser_saf_fil from "../img/sswpIcons/SewersCulvertsMains/ser_saf_fil.png";
import ser_esb_not from "../img/sswpIcons/SewersCulvertsMains/ser_esb_net_not.png";
import ser_war_sig from "../img/sswpIcons/SewersCulvertsMains/ser_war_sig.png";
import ser_iso_loc_out from "../img/sswpIcons/SewersCulvertsMains/ser_iso_loc_out.png";
import ser_gas_bot_sto from "../img/sswpIcons/SewersCulvertsMains/ser_gas_bot_sto.png";
import ser_gas_com_not from "../img/sswpIcons/SewersCulvertsMains/ser_gas_com_not.png";
import ser_iri_mai from "../img/sswpIcons/SewersCulvertsMains/ser_iri_wat_wat_mai.png";
import ser_iri_fou_sew from "../img/sswpIcons/SewersCulvertsMains/ser_iri_wat_fou_sew.png";
import ser_cul_sto_dra from "../img/sswpIcons/SewersCulvertsMains/ser_sto_dra.png";
import ser_no_tip from "../img/sswpIcons/SewersCulvertsMains/ser_no_tip.png";
import ser_saf_tip_are from "../img/sswpIcons/SewersCulvertsMains/ser_saf_tip_are.png";
import ser_sit_spe_met_sta from "../img/sswpIcons/SewersCulvertsMains/ser_sit_spe_met.png";
//import ser_gas_bot_sto from "../img/sswpIcons/PlantAndEquipment/sswpicon_plant_and_equipment_gas_bottle_storage.jpg";

const json = {
    icon: ser_haz_lev,
    name: "Services",
    text: "",
    icons: {
        ser_sur_map: {
            name: "Survey Map",
            icon: ser_sur_map,
            text: (
                <ul>
                    <ListItem text="You must undertake a visual survey for overhead lines before you begin works. Pay particular attention for overhead ESB and telecom cables, including through trees and other roadside objects." />
                    <ListItem text="You require drawings of the underground services present." />
                    <ListItem text="Their positions must be verified by a CSCS Location of Underground Services Cardholder, who will mark their locations on the ground, before work commences." />
                </ul>
            )
        },
        ser_ser_sup: {
            name: "Service Supplier",
            icon: ser_ser_sup,
            text: (
                <ul>
                    <ListItem text="Before works begin, and where services are unknown, the relevant utility (ESB, Bord Gáis etc) must be contacted to obtain drawings and advice on the position of underground or overhead services." />
                </ul>
            )
        },
        ser_dec_mar: {
            name: "Detect & Mark",
            icon: ser_det_mar,
            text: (
                <ul>
                    <ListItem text="This work requires a CSCS Location of Underground Services Cardholder" />
                    <ListItem text="The cardholder should have a services layout drawing prior to commencement" />
                    <ListItem text="The area must be scanned by the cardholder with a detector and the positions of services carefully marked." />
                    <ListItem text="The area must be re-scanned and marked by the cardholder if any of the works remove/cover the existing markings." />
                </ul>
            )
        },
        ser_saf_fil: {
            name: "Safety File/ O+M Manual",
            icon: ser_saf_fil,
            text: (
                <ul>
                    <ListItem text="Before beginning works on buildings or electric installations consult the Safety File or Operation and Maintenance Manual." />
                    <ListItem text="Any uprade or modification works will require the Safety File/ O+M manual to be updated." />
                </ul>
            )
        },
        ser_war_sig: {
            name: "Warning Signs",
            icon: ser_war_sig,
            text: (
                <ul>
                    <ListItem text="Signs will alert workers/public that they are approaching high-risk areas (e.g. exclusion zones, fall risks etc)." />
                    <ListItem text="Signs should use standardised graphical pictograms to communicate the hazard and may have supplementary information in written format." />
                    <Li>
                        <Typography variant="title">
                            {" "}
                            Graphical symbols should NOT be combined to convey
                            more than one safety message. E.g. separate symbols
                            for hard hat and eye protection.
                        </Typography>
                        <StyledTable>
                            <tr>
                                <th>Sign Type </th>
                                <th>Meaning</th>
                                <th>Shape & Colour</th>
                            </tr>
                            <tr>
                                <td>Prohibition</td>
                                <td>Not permitted</td>
                                <td>Shape: Round </td>
                            </tr>
                            <tr>
                                <td />
                                <td />
                                <td> Backing colour: White</td>
                            </tr>
                            <tr>
                                <td />
                                <td />
                                <td>Symbol colour: Black with red diagonal</td>
                            </tr>
                            <tr>
                                <td />
                                <td />
                                <td />
                            </tr>
                            <tr>
                                <td>Fire fighting </td>
                                <td>Location and identification of type</td>
                                <td>Shape: Rectangle </td>
                            </tr>
                            <tr>
                                <td />
                                <td />
                                <td>Backing colour: Red</td>
                            </tr>
                            <tr>
                                <td />
                                <td />
                                <td>Symbol colour: White</td>
                            </tr>
                            <tr>
                                <td />
                                <td />
                                <td>Shape: Triangle</td>
                            </tr>
                            <tr>
                                <td>Warning </td>
                                <td>Take precaution</td>
                                <td>Shape: Triangle</td>
                            </tr>
                            <tr>
                                <td />
                                <td />
                                <td>Backing colour: Yellow</td>
                            </tr>
                            <tr>
                                <td />
                                <td />
                                <td>Symbol colour: Black</td>
                            </tr>
                            <tr>
                                <td>Mandatory</td>
                                <td>You Must</td>
                                <td>Shape: Round</td>
                            </tr>
                            <tr>
                                <td />
                                <td />
                                <td>Backing colour: Blue</td>
                            </tr>
                            <tr>
                                <td />
                                <td />
                                <td> Symbol colour: White</td>
                            </tr>
                            <tr>
                                <td />
                                <td />
                                <td />
                            </tr>
                            <tr>
                                <td>Emergency Escape </td>
                                <td>Escape route </td>
                                <td>Shape: Rectangle</td>
                            </tr>
                            <tr>
                                <td />
                                <td />
                                <td>Backing colour: Green</td>
                            </tr>
                            <tr>
                                <td />
                                <td />
                                <td> Symbol colour: White</td>
                            </tr>
                            <tr>
                                <td>Supplementary Information</td>
                                <td>Additional Info </td>
                                <td>Shape: Rectangle</td>
                            </tr>
                            <tr>
                                <td />
                                <td />
                                <td> Backing colour: White</td>
                            </tr>
                            <tr>
                                <td />
                                <td />
                                <td>Symbol colour: Black</td>
                            </tr>
                            <tr>
                                <td>Obstacles </td>
                                <td>Collision risk </td>
                                <td>Chevron</td>
                            </tr>
                            <tr>
                                <td />
                                <td />
                                <td>Black/Yellow</td>
                            </tr>
                            <tr>
                                <td />
                                <td />
                                <td> Red/White</td>
                            </tr>
                            <tr>
                                <td>Traffic Route</td>
                                <td>Vehicles to keep between</td>
                                <td>Continuous white or yellow lines.</td>
                            </tr>
                        </StyledTable>
                    </Li>
                </ul>
            )
        },
        ser_div_off: {
            name: "Divert/ Off",
            icon: ser_div_off,
            text: (
                <ul>
                    <ListItem text="If this control is selected, the services owner (electric, gas, water etc) must be contacted to divert or turn off their service at the work zone." />
                    <ListItem text="Work may only proceed when the services owner confirms the action has been completed." />
                </ul>
            )
        },
        ser_iso_loc_out: {
            name: "Isolate/ Lock Out",
            icon: ser_iso_loc_out,
            text: (
                <ul>
                    <ListItem text="This is required when undertaking electrical works and electric power to the site remains live" />
                    <ListItem text="A permit to work system is required (personnel and timings)" />
                    <ListItem text=" The required network needs to be isolated from the main system, with the isolation point locked out and tagged." />
                    <ListItem text="The isolation needs to be verified before any work can commence." />
                </ul>
            )
        },
        ser_tag_on_tag_off: {
            name: "Tagon/ Tagoff",
            icon: ser_tag_on_off,
            text: (
                <ul>
                    <ListItem text="Tags are a visible means of isolating a hazard. They can be used as part of a permit to work system." />
                    <ListItem text="They form part of a system to prevent the inadvertent/ premature enabling of an energy source after the source has been “locked-out”." />
                    <ListItem text="Tags should only be removed (Tag Off) by the person who placed them (Tag On). The tag should include details on the date it was placed, expected expiry, and the name of the person who placed it. They should also give a warning, not to remove them (unless you are an authorized person). They may also include checklists to be completed before beginning the task, or after completing a task." />
                    <ListItem text="They should be highly visible, durable, weather/environment resistant and have a clear signing/marking system that will not be effected by weather/environment." />
                    <Li>
                        <Typography variant="title">
                            For confined spaces; Tags can be used to identify
                        </Typography>
                        <ol>
                            <ListItem text="Asphyxiation hazards, telling people not to enter unless they have a permit" />
                            <ListItem text="Confined Space, telling people not to enter unless they have a permit" />
                            <ListItem text="I Am In, telling people who is in the confined space, and when you should be out." />
                        </ol>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            For exclusion/ electrical hazards; Tags can be used
                            to identify
                        </Typography>
                        <ol>
                            <ListItem text="Entry Prohibited/Do Not Enter, telling people not to enter unless they have a permit" />
                            <ListItem text="Out of Service/Do Not Operate, telling people not to use the tool/ equipment" />
                            <ListItem text="Locked Out, telling people not to turn on the service or interfere with any of the controls/switches" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        ser_gas_bot_sto: {
            name: "Gas Bottle Storage",
            icon: ser_gas_bot_sto,
            text: (
                <ul>
                    <ListItem text="Cylinders must be upright during handling, transport, storage and use" />
                    <ListItem text="If they have been laid down, they must be placed upright for a minimum of 30 minutes before use" />
                    <ListItem text="Protect cylinders from sunlight" />
                    <ListItem text="Cannot be toppled, dropped or rolled on their side" />
                    <ListItem text="Do NOT use valves as lifting points" />
                    <ListItem text="If leak is detected, stop leak if possible without personal risk. Keep people away. Isolate and remove sources of ignition. Ensure ventilation." />
                </ul>
            )
        },
        ser_bar_fen_hoa: {
            name: "Barriers/ Fencing/ Hoarding",
            icon: ser_bar_fen_hoa,
            text: (
                <ul>
                    <ListItem text="Barriers must be used around any unattended openings or excavations." />
                    <ListItem text="Barriers should be used to exclude pedestrians from the works site." />
                    <ListItem text="Barriers should be at least 1.0m high and have a high visibility (red/white bar) rail. The bottom rail should be a maximum of 200mm from ground level. Be careful of hazard created by feet." />
                </ul>
            )
        },
        ser_esb_net_not: {
            name: "ESB Networks",
            icon: ser_esb_not,
            text: (
                <ul>
                    <ListItem text="If electricity services are unkown, the ESB (or other network operator) must be notified before works begin." />
                    <ListItem text="You must have drawings/ advice from the ESB before beginning." />
                </ul>
            )
        },
        ser_gas_com_not: {
            name: "Gas Company Notification",
            icon: ser_gas_com_not,
            text: (
                <ul>
                    <ListItem text=" If gas services are unkown, the Bord Gáis (or other network operator) must be notified before works begin." />
                    <ListItem text="You must have drawings/ advice from the Bord Gáis before beginning. " />
                </ul>
            )
        },
        ser_iri_wat_wat_mai: {
            name: "Irish Water - Main",
            icon: ser_iri_mai,
            text: (
                <ul>
                    <ListItem text="If water services are unknown, Irish Water (or other network operator) must be notified before works begin." />
                    <ListItem text=" You must have drawings/ advice from Irish Water before beginning." />
                </ul>
            )
        },
        ser_iri_wat_fou_sew: {
            name: "Irish Water - Foul Sewer",
            icon: ser_iri_fou_sew,
            text: (
                <ul>
                    <ListItem text="If foul services are unknown, Irish Water (or other network operator) must be notified before works begin." />
                    <ListItem text="You must have drawings/ advice from Irish Water before beginning." />
                </ul>
            )
        },
        ser_sto_dra: {
            name: "Culvert/ Storm Drain",
            icon: ser_cul_sto_dra,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            {" "}
                            Assess whether works constitute a confined space and
                            apply the necessary controls
                        </Typography>
                        <ol>
                            <ListItem text="Lack of oxygen" />
                            <ListItem text="Presence of gases, dust or other contaminant" />
                            <ListItem text="Risk of fire or explosion" />
                            <ListItem text="Requirement for rescue" />
                        </ol>
                    </Li>
                    <ListItem text="Follow weather forecast and do not work in conditions that create the potential for high water flows" />
                    <ListItem text=" Ensure all tools and equipment are securely fastened" />
                    <ListItem text="Do not eat, drink or smoke while working" />
                    <ListItem text="Wear waterproof PPE, including gloves, footwear, bottoms etc. Ensure cuts are covered and be aware of risk of Weils Disease." />
                </ul>
            )
        },
        ser_han_dig: {
            name: "Hand Dig",
            icon: ser_han_dig,
            text: (
                <ul>
                    <ListItem text="The location of services should be marked out prior to digging commencing." />
                    <ListItem text="Mechanical cutting or digging around services is not permitted. Such services need to be uncovered by hand before mechanical means can continue." />
                    <ListItem text="Dig with extra care around services. Do NOT use picks or other impact tools." />
                </ul>
            )
        },
        ser_no_tip: {
            name: "No Tipping",
            icon: ser_no_tip,
            text: (
                <ul>
                    <ListItem text="The ESB should be consulted to establish the voltages present." />
                    <ListItem text="Follow the practice outlined in “Avoiding Danger from Overhead Electricity Lines”" />
                    <Li>
                        <Typography variant="title">
                            The Hazard Zone alongside overhead lines should be
                            isolated from plant activity by physical means
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Voltage</th>
                                    <th>
                                        Distance from edge of Hazard Zone to
                                        overhead line
                                    </th>
                                </tr>
                                <tr>
                                    <td>LV, 10kV, 20kV, 38kV</td>
                                    <td>6.0m</td>
                                </tr>
                                <tr>
                                    <td>110kV, 220kV, 400kV</td>
                                    <td>10.0m</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            The Exclusion Zone around live wires must never be
                            breached.
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Voltage</th>
                                    <th>Radius around live wire</th>
                                </tr>
                                <tr>
                                    <td>Insulated LV</td>
                                    <td>1.0m</td>
                                </tr>
                                <tr>
                                    <td>Bare LV, 10kV, 20kV, 38kV</td>
                                    <td>3.0m</td>
                                </tr>
                                <tr>
                                    <td>110kV</td>
                                    <td>4.5m</td>
                                </tr>
                                <tr>
                                    <td>220kV</td>
                                    <td>6.0m</td>
                                </tr>
                                <tr>
                                    <td>400kV</td>
                                    <td>8.0m</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                    <ListItem text="Crossing points for plant underneath overhead lines should be provided using “goalposts”. These should be max 9m width and 4.2m max height." />
                    <ListItem text="No Tip Zones can be exclusively used for road surfacing operations. These are set perpendicular to the road direction, such that no point of the no tip zone is closer than 3m to the overhead line. They must be clearly marked and provided with a dedicated banksman in direct communication with the plant operator(s)." />
                </ul>
            )
        },
        ser_oh_lin: {
            name: "Over Head Lines",
            icon: ser_oh_lin,
            text: (
                <ul>
                    <ListItem text="The ESB should be consulted to establish the voltages present." />
                    <ListItem text="The risks and necessary controls associated with overhead lines need to be assessed during the day, and during the planning stage before works begin." />
                    <ListItem text="Follow the practice outlined in “Avoiding Danger from Overhead Electricity Lines”" />
                    <Li>
                        <Typography variant="title">
                            The Hazard Zone alongside overhead lines should be
                            isolated from plant activity by physical means
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Voltage</th>
                                    <th>
                                        Distance from edge of Hazard Zone to
                                        overhead line
                                    </th>
                                </tr>
                                <tr>
                                    <td>LV, 10kV, 20kV, 38kV</td>
                                    <td>6.0m</td>
                                </tr>
                                <tr>
                                    <td>110kV, 220kV, 400kV</td>
                                    <td>10.0m</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            The Exclusion Zone around live wires must never be
                            breached.
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Voltage</th>
                                    <th>Radius around live wire</th>
                                </tr>
                                <tr>
                                    <td>Insulated LV</td>
                                    <td>1.0m</td>
                                </tr>
                                <tr>
                                    <td>Bare LV, 10kV, 20kV, 38kV</td>
                                    <td>3.0m</td>
                                </tr>
                                <tr>
                                    <td>110kV</td>
                                    <td>4.5m</td>
                                </tr>
                                <tr>
                                    <td>220kV</td>
                                    <td>6.0m</td>
                                </tr>
                                <tr>
                                    <td>400kV</td>
                                    <td>8.0m</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                    <ListItem text="Crossing points for plant underneath overhead lines should be provided using “goalposts”. These should be max 9m width and 4.2m max height." />
                    <ListItem text="No Tip Zones can be exclusively used for road surfacing operations. These are set perpendicular to the road direction, such that no point of the no tip zone is closer than 3m to the overhead line. They must be clearly marked and provided with a dedicated banksman in direct communication with the plant operator(s)." />
                </ul>
            )
        },
        ser_saf_tip_are: {
            name: "Safe Tipping Area",
            icon: ser_saf_tip_are,
            text: (
                <ul>
                    <ListItem text="The ESB should be consulted to establish the voltages present." />
                    <ListItem text="The risks and necessary controls associated with overhead lines need to be assessed during the day, and during the planning stage before works begin." />
                    <ListItem text="Follow the practice outlined in “Avoiding Danger from Overhead Electricity Lines”" />
                    <Li>
                        <Typography variant="title">
                            The Hazard Zone alongside overhead lines should be
                            isolated from plant activity by physical means{" "}
                        </Typography>
                        <StyledTable>
                            <tr>
                                <th>Voltage</th>
                                <th>
                                    Distance from edge of Hazard Zone to
                                    overhead line
                                </th>
                            </tr>
                            <tr>
                                <td>LV, 10kV, 20kV, 38kV</td>
                                <td>6.0m</td>
                            </tr>
                            <tr>
                                <td>110kV, 220kV, 400kV</td>
                                <td>10.0m</td>
                            </tr>
                        </StyledTable>
                    </Li>
                    <ListItem text="Crossing points for plant underneath overhead lines should be provided using “goalposts”. These should be max 9m width and 4.2m max height." />
                </ul>
            )
        },
        ser_per_to_wor: {
            name: "Permit To Work",
            icon: ser_per_to_wor,
            text: (
                <ul>
                    <ListItem text="This formal system ensures the required controls are in place before beginning a task with a high risk hazard." />
                    <ListItem text="The permit system identifies the controls that must be in place to allow the task to begin. The implementation of these controls must be signed off by an appointed seperate individual, before an operative is permitted to begin the task." />
                    <ListItem text="The permit system should also state the conditions to be met after work is completed and be signed off by the operative (and verified by the appointed individual)." />
                </ul>
            )
        },
        ser_no_fla: {
            name: "No Flames",
            icon: ser_no_fla,
            text: (
                <ul>
                    <ListItem text="Ignition sources (lighters, electric switches, sparks, static electricity etc) must be kept away from areas where there is a risk of gas." />
                </ul>
            )
        },
        ser_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: ser_sit_spe_met_sta,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};
export default json;
